import { createContext, useContext } from 'react';
import { type AppThemeMode } from './index';

type ThemeModeContextValue = {
  mode: AppThemeMode;
  toggleMode: () => void;
};

export const ThemeModeContext = createContext<ThemeModeContextValue | undefined>(undefined);

export const useThemeMode = () => {
  const context = useContext(ThemeModeContext);
  if (!context) {
    throw new Error('useThemeMode must be used within ThemeModeProvider');
  }
  return context;
};
